export const resetState = (state, preserve = {}) =>
  Object.fromEntries(
    Object.keys(state).map(k => [k, preserve[k] ?? ""])
  );
